var ContentService = require('services/content-service');

var CustomizationService = function() {
  this.getEFInitLoads = function(ef) {
    return [ef.enrollment.loadData(), ef.customizations.fetch(), ef.program.fetch()];
  };

  this.getCustomizationCollectionUrl = function(self, ef) {
    return ef.url('/sdk/enrollments/' + self.enrollment.get('id') +'/' + self.fileName);
  };

  this.parseCustomizationCollection = function(response, options) {
    if(response) {
      response.forEach((model) => {
        if(model) {
          model.idAttribute = 'type';
        }
      });
    }
    return response;
  };

  this.load = function() {
    return EF.customizations.fetch();
  };
  
  this.getById = function(customizationCollection, id) {
    const type = id.type || id;
    return customizationCollection.findWhere(c => c.get('type') === type);
  };

  this.findByType = function(customizationCollection, type) {
    return customizationCollection.findWhere(c => c.get('type') === type);
  };

  this.getCustomizationByKeyAndSlug = function(customizationCollection, key, slug) {
    var collection = customizationCollection.findWhere(c => c.get('type') === key);
    if(collection) {
      return collection.getBySlug(slug);
    }
  };

  this.getByKeyAndPage = function(customizations, key, moduleKey, activityKey, pageKey) {
    var collection = customizations.get(key);
    if(collection) {
      return collection.getByPage(moduleKey, activityKey, pageKey);
    }
  };
};

module.exports = new CustomizationService();
